import { render, staticRenderFns } from "./addServer.vue?vue&type=template&id=63be9fd4&"
import script from "./addServer.vue?vue&type=script&lang=js&"
export * from "./addServer.vue?vue&type=script&lang=js&"
import style0 from "./addServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports